module.exports = __webpack_public_path__ + "static/media/google-play.88c54782.png";